import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import laptopImage from "../../assets/laptopImage.png";

export default function MakeDiff() {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden bg-[#f6fcff] top-[-120px]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 pt-8 sm:pt-5 sm:pb-5 md:grid-cols-2 lg:gap-20">
        {/* Left: Laptop mockup */}
        <div className="relative flex justify-start w-full h-full">
          <img
            src={laptopImage}
            alt="Platform screenshot shown on a laptop"
            className="w-full h-full object-cover relative left-[-80px]"
          />
        </div>

        {/* Right: Text content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3 className="font-arya text-xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
            {t("about.howTitle")}
          </h3>
          <p className="mt-6 text-md leading-7 text-gray-600">
            {t("about.howDescription")}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
